import React, { useEffect, useState } from 'react';
import useSiteConfig from '@components/Hooks/useSiteConfig';

interface Props {
  title: string
}

const Logo: React.FC<Props> = (props) => {

  const site_config = useSiteConfig();
  const [width, setWidth] = useState<number>(1);

  useEffect(() => {
    if (site_config?.title) {
      const size = getTextWidth(site_config.title);
      setWidth(size);
    }
  }, [site_config]);

  const getTextWidth = (title: string) => {

    const text = document.createElement("span");
    document.body.appendChild(text);

    text.style.font = "times new roman";
    text.style.fontSize = 16 + "px";
    text.style.height = 'auto';
    text.style.width = 'auto';
    text.style.position = 'absolute';
    text.style.whiteSpace = 'no-wrap';
    text.innerHTML = title;

    const x = text.clientWidth;

    text.style.display = 'none';

    return Math.ceil(x);
  }

  const addTitle = () => {
    if (props.title == (site_config?.title ?? '')) {
      return (
        <>
          {props.title}
        </>
      );
    }
    return (
      <>
        {props.title}
        <span style={{ fontSize: '.5em' }}>:{site_config?.title}</span>
      </>
    );
  }

  const getTitleHeight = () => {
    return 'calc(min(' +
      (Math.round(100 * (400 / (width - 20))) / 100) + 'vw' +
      ', ' +
      ((Math.round(100 * (294 / (width - 20))) / 100)) + 'rem' +
      '))';
  }

  return (
    <>
      <style>{`
        @media (max-width: 767.98px) {
          font-size: calc(min(${Math.round(600 / width)}vw, ${(Math.round(10 * (448 / width)) / 10)}rem)) !important;
        }
    `}</style>
      <div id="logo-buttons" style={{ position: 'relative', minHeight: '17vw', height: '17vw', paddingBottom: 90 }}>
        <div id="logo-subsubtitle">FLORIDA</div>
        <div id="logo-subtitle">{site_config?.division}</div>
        <div id="logo-title" style={{
          top: -16,
          paddingTop: (width / 7) + 'px',
          whiteSpace: 'nowrap',
          fontSize: getTitleHeight(),
          lineHeight: getTitleHeight()
        }}>{addTitle()}
          <div className='telephone'>
            <a href={'tel:' + site_config?.telephone} style={{ color: '#fff', textDecoration: 'none !important' }}>
              {site_config?.display_phone ?? site_config?.telephone}
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Logo;